/* eslint-disable import/no-cycle */
import { PlatformService } from '@ce-cfbdigital/cgl-cfb-fe-foundation';

import appConfig from '../../../app.config';
import oktaAuth from '../auth/oktaAuth';
import { INLINE_TRANSLATIONS } from '../constants';
import { getAppConfig } from '.';
import { cacheAccountAndRegion } from './common';

const { apiWrapperConfig } = appConfig;
const getGenericErrors = () => {
  const { lang } = getAppConfig('locale');
  const defaultErrors = getAppConfig(INLINE_TRANSLATIONS);
  return defaultErrors[lang];
};

/**
 * get default request headers
 */
const getRequestHeaders = (() => {
  let fibiPayload;
  return async () => {
    if (!fibiPayload) {
      const { accounts = [], regions = [] } = await cacheAccountAndRegion();
      const selectedRegion = regions.find(item => item.selected);
      const selectedAccount = accounts.find(item => item.selected);
      const region = selectedRegion ? selectedRegion.shortname : '';
      const account = selectedAccount ? selectedAccount.shortname : '';
      fibiPayload = JSON.stringify({
        region,
        account,
        customerType: ''
      });
    }
    return { 'X-FIBIPayload': fibiPayload };
  };
})();

/**
 * The callAndLog method - it is used as a wrapper for APi calls where in we can call the api and log the result
 * @property {string} url - API endpoint to hit
 * @property {Object} reqData - contains info like url, api method, headers etc
 * @property {string} idToken - optional, contains idToken
 */

const callAndLog = async (reqData = {}, idToken = null) => {
  const currentTime = Date.now();
  const { isHeaders = false } = reqData;
  let requestHeaders = {};
  if (isHeaders) {
    requestHeaders = await getRequestHeaders();
  }
  const apiObject = isHeaders ? { ...reqData, headers: { ...reqData.headers, ...requestHeaders } } : { ...reqData };
  const metaData = idToken ? { ...apiObject, headers: { ...apiObject.headers, idToken } } : { ...apiObject };

  const apiPromise = PlatformService(metaData, getGenericErrors(), apiWrapperConfig, oktaAuth);

  const logInfo = {};

  apiPromise
    .then(() => {
      const responseTime = (Date.now() - currentTime) / 1000;
      logInfo.responseTime = responseTime;
    })
    .catch(err => {
      const responseTime = (Date.now() - currentTime) / 1000;
      logInfo.responseTime = responseTime;
      logInfo.error = err;
      if (apiObject.data) logInfo.payload = apiObject.data;
    });
  return apiPromise;
};

const Get = (url, isHeaders, responseType) =>
  callAndLog({
    url,
    method: 'GET',
    isHeaders,
    responseType
  });

const Post = (url, data, isHeaders, headers = {}) =>
  callAndLog({
    url,
    method: 'POST',
    data,
    isHeaders,
    headers
  });

const Put = (url, data, isHeaders) =>
  callAndLog({
    url,
    method: 'PUT',
    data,
    isHeaders
  });

const Patch = (url, data, isHeaders) =>
  callAndLog({
    url,
    method: 'PATCH',
    data,
    isHeaders
  });
const Delete = (url, isHeaders) =>
  callAndLog({
    url,
    method: 'DELETE',
    isHeaders
  });

const BlobDownload = (url, data, isHeaders, method = 'POST') =>
  callAndLog({
    url,
    isHeaders,
    method,
    data,
    responseType: 'blob'
  });

const Download = async (url, isHeaders) => {
  const idToken = await oktaAuth.getIdToken();
  return callAndLog(
    {
      url,
      isHeaders,
      method: 'GET',
      responseType: 'blob'
    },
    idToken
  );
};

const Upload = (url, data, headers) => {
  const { idToken } = headers;
  return callAndLog(
    {
      url,
      isHeaders: false,
      method: 'POST',
      data,
      'Content-Type': headers['Content-Type']
    },
    idToken
  );
};
export { BlobDownload, Delete, Download, Get, Patch, Post, Put, Upload };
